import styles from './priceBreakdown.module.css'
import { useDataTypesHooks } from '../../../../features/data-types'
import { FieldType } from '../../../../features/ui'
import { PriceOutlineType } from '../../hooks/types'

type Props = {
    data: PriceOutlineType
    showDetail?: boolean
    discountLabel?: string
}

export const PriceBreakdown = (props: Props) => {
    const { data, showDetail = true, discountLabel } = props
    const { subtotal, customerAdjustmentAmount, discountedAmount, paymentTypeAdjustmentAmount, totalWithoutVAT, vatAmount, perceptionsAmount, total } = data

    const { formatValue } = useDataTypesHooks()

    const subtotalAmount = subtotal + (customerAdjustmentAmount > 0 ? customerAdjustmentAmount : 0)
    
    const adjustmentLabel = (positive: boolean) => positive ? 'Recargo' : 'Descuento'

    return (
        <div className={styles.container}>
            {showDetail && (
                <>
                    <div>
                        Subtotal: {formatValue(subtotalAmount, FieldType.PRICE)}
                    </div>
                    {customerAdjustmentAmount < 0 && (
                        <div>
                            {adjustmentLabel(customerAdjustmentAmount > 0)} Cliente: {formatValue(customerAdjustmentAmount, FieldType.PRICE)}
                        </div>
                    )}
                    {discountedAmount !== 0 && (
                        <div>
                            {discountLabel || 'Descuentos'}: {formatValue(discountedAmount, FieldType.PRICE)}
                        </div>
                    )}
                    {paymentTypeAdjustmentAmount !== 0 && (
                        <div>
                            {adjustmentLabel(paymentTypeAdjustmentAmount > 0)} M. de Pago: {formatValue(paymentTypeAdjustmentAmount, FieldType.PRICE)}
                        </div>
                    )}
                    {vatAmount !== 0 && (customerAdjustmentAmount !== 0 || discountedAmount !== 0 || paymentTypeAdjustmentAmount !== 0) && (
                        <div>
                            Total s/IVA: {formatValue(totalWithoutVAT, FieldType.PRICE)}
                        </div>
                    )}
                    {vatAmount !== 0 && (
                        <div>
                            IVA: {formatValue(vatAmount, FieldType.PRICE)}
                        </div>
                    )}
                    {perceptionsAmount !== 0 && (
                        <div>
                            Percepciones: {formatValue(perceptionsAmount, FieldType.PRICE)}
                        </div>
                    )}
                </>
            )}
            <div className={styles.totalPrice}>
                Total: {formatValue(total, FieldType.PRICE)}
            </div>
        </div>
    )
}
